import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivityStreamComponent } from './activity-stream.component';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  declarations: [ActivityStreamComponent],
  exports: [ActivityStreamComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgxSpinnerModule
  ]
})
export class ActivityStreamModule { }
